/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { Button } from "../ui/button";
import { RefreshCcw } from "lucide-react";
import Confirmation from "../Confirmation";
import { API, get } from "../../config";

const CDDVerifyCheck = ({
  listData,
  setCddId,
  setLoading,
  cddId,
  fecthData,
}) => {
  const [confirmVerify, setConfirmVerify] = useState(false);

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
    } else {
      setCddId(id);
    }
    setConfirmVerify(!confirmVerify);
  };

  const handleVerifyID = async () => {
    try {
      toggleConfirmVerify();
      setLoading(true);
      await get(`${API.GET_CDD_VERFIY_CHECK}/${cddId}`);
      setLoading(false);
      fecthData();
    } catch (error) {
      setLoading(false);
      fecthData();
    }
  };

  return (
    <>
      {/* <span>/</span> */}
      <Button
        size={"sm"}
        className="h-6 px-2"
        onClick={() => {
          toggleConfirmVerify(listData?.id, listData);
        }}
      >
        <div className="flex items-center gap-2">
          <RefreshCcw size={14} />
          <span>Show</span>
        </div>
      </Button>

      <Confirmation
        title={"Check Status"}
        open={confirmVerify}
        setOpen={setConfirmVerify}
        toggleShow={() => {
          toggleConfirmVerify();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>Would you like check the kyc verification status?</div>
          </>
        }
        okAction={async () => {
          handleVerifyID();
        }}
        cancelAction={() => {
          setCddId(null);
          setConfirmVerify(!confirmVerify);
        }}
      />
    </>
  );
};

export default CDDVerifyCheck;
